import { expVal } from '@atlassian/jira-feature-experiments';
import { fireCjnNav4PlacementExposed, type CreateAnalyticsEvent } from '../analytics/index.tsx';
import { jiraUserIsActiveAfterDate } from './jiraUserIsActiveAfterDate.tsx';

const CJN_NAV4_AA_EXPERIMENT_START_DATE = new Date('2026-05-01');

export const isExcludedForNav4PlacementAA = async (
	cloudId: string,
	userId: string,
	createAnalyticsEvent: CreateAnalyticsEvent,
): Promise<boolean> => {
	if (!(await jiraUserIsActiveAfterDate(cloudId, userId, CJN_NAV4_AA_EXPERIMENT_START_DATE))) {
		return false;
	}

	if (
		['control', 'variation'].includes(
			expVal('puma_expt_cjn-nav4-jira-aa', 'cohort', 'not-enrolled'),
		)
	) {
		fireCjnNav4PlacementExposed(
			createAnalyticsEvent,
			'crossJoinNudgesNav4PlacementAa',
			'puma_expt_cjn-nav4-jira-aa',
			expVal('puma_expt_cjn-nav4-jira-aa', 'cohort', 'not-enrolled'),
			'confluence', // AA test only run for confluence
		);
	}

	// Never excluded for AA test
	return false;
};
